import { render, staticRenderFns } from "./CatalogVehicleEstimate.vue?vue&type=template&id=2aed42e0&"
import script from "./CatalogVehicleEstimate.vue?vue&type=script&lang=js&"
export * from "./CatalogVehicleEstimate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports